import { type JSX, SyntheticEvent } from "react";

import ButtonGroup from "@mui/material/ButtonGroup";
import { SxProps } from "@mui/material/styles";
import {
  IconButtonWithTooltip,
  SubstructureInstanceButton,
  SubstructureInstanceButtonMapping,
  useSubstructureLayout,
} from "@plansoft-configuration-renderer/components";
import { ConfigurationObjectResult } from "@plansoft-configuration-renderer/configuration-api";

function stopPropagation(e: SyntheticEvent): void {
  e.stopPropagation();
}

const STATUS_BUTTON_SX: SxProps = { cursor: "default" };

interface SubstructureInstanceButtonsProps {
  substructure: ConfigurationObjectResult;
  size?: "small" | "medium" | "large";
  sx?: SxProps;
}

export function CustomSubstructureInstanceButtons(
  props: SubstructureInstanceButtonsProps,
): JSX.Element {
  const { instanceButtonOrder } = useSubstructureLayout();
  const { substructure, size, sx } = props;

  return (
    <ButtonGroup
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
      size={size}
    >
      {instanceButtonOrder
        .map((control) => {
          const MappedComponent = SubstructureInstanceButtonMapping[control];
          if (!MappedComponent) {
            return null;
          }

          const isStatus = control === SubstructureInstanceButton.Status;

          return (
            <MappedComponent
              key={control}
              substructure={substructure}
              ButtonComponent={IconButtonWithTooltip}
              size={size}
              sx={isStatus ? STATUS_BUTTON_SX : sx}
            />
          );
        })
        .filter(Boolean)}
    </ButtonGroup>
  );
}

CustomSubstructureInstanceButtons.displayName =
  "CustomSubstructureInstanceButtons";
